module.exports = __webpack_public_path__ + "img/bg_1.b664f105.jpg";